export default {
  "zh": {
    "grid": {
      "groupPanelEmpty": "拖動標題列並將其放在此處以按該列分組",
      "pagerItemsPerPage": "項每頁",
      "pagerInfo": "{0} - {1} 共 {2} 項",
      "pagerFirstPage": "第一頁",
      "pagerPreviousPage": "上一頁",
      "pagerNextPage": "下一頁",
      "pagerLastPage": "最後頁",
      "pagerPage": "頁",
      "pagerOf": "共",
      "filterClearButton": "清除",
      "filterEqOperator": "等於",
      "filterNotEqOperator": "不等於",
      "filterIsNullOperator": "為NULL值",
      "filterIsNotNullOperator": "非NULL值",
      "filterIsEmptyOperator": "為空",
      "filterIsNotEmptyOperator": "非空",
      "filterStartsWithOperator": "開始",
      "filterContainsOperator": "包含",
      "filterNotContainsOperator": "不包含",
      "filterEndsWithOperator": "結束",
      "filterGteOperator": "大於或等於",
      "filterGtOperator": "大於",
      "filterLteOperator": "小於或等於",
      "filterLtOperator": "小於",
      "filterIsTrue": "為True",
      "filterIsFalse": "為False",
      "filterBooleanAll": "(所有)",
      "filterAfterOrEqualOperator": "晚於或等於",
      "filterAfterOperator": "晚於",
      "filterBeforeOperator": "早於",
      "filterBeforeOrEqualOperator": "早於或等於",
      "noRecords": "沒有記錄"
    },
    "dateinput": {
      "increment": "增大",
      "decrement": "減小"
    },
    "calendar": {
      "today": "今天"
    },
    "datepicker": {
      "toggleCalendar": "切换日曆"
    },
    "timepicker": {
      "now": "現在",
      "set": "確定"
    },
    "datetimepicker": {
      "date": "日期",
      "time": "時間",
      "cancel": "取消",
      "set": "確定"
    },
    "dropdowns": {
      "nodata": "沒有資料",
      "clear": "清除"
    },
    "numerictextbox": {
      "increment": "增大",
      "decrement": "減小"
    },
    "upload": {
      "cancel": "取消",
      "clearSelectedFiles": "清除",
      "dropFilesHere": "拖移檔案到此上傳",
      "headerStatusUploaded": "完成",
      "headerStatusUploading": "上傳中...",
      "invalidFileExtension": "禁止的檔案類型",
      "invalidFiles": "無效的檔案，請檢查檔案上傳配置",
      "invalidMaxFileSize": "檔案太大",
      "invalidMinFileSize": "檔案太小",
      "remove": "移除",
      "retry": "重試",
      "select": "", // 選擇檔案
      "uploadSelectedFiles": "上傳",
      "total": "總計",
      "files": "檔案"
    },
    "sortable": {
      "noData": "沒有資料"
    }
  }
}